// datatable related plugins
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import ChangeInfoModal from "pages/Error-invoice/modal/ChangeInfoModal";
import SendMailModal from "pages/IssueInvoice/modal/SendMailModal";
import React, { useEffect, useState } from "react";
import { selectFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import {
  errorInvoicesDelete,
  getListErrorInvoices,
  resetDownloadXmlErrorInvoices,
  resetEditErrorInvoices,
  resetErrorInvoicesDelete,
  resetExportInvoice,
  resetListErrorInvoices,
  resetPreviewPdfErrorInvoice,
  resetdownloadPDFInvoices,
  setColumnVisibleRegistryInvoices,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
} from "store/data-format/actionTypes";
import {
  DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  ERROR_INVOICES_DELETE_FAIL,
  ERROR_INVOICES_DELETE_SUCCESS,
  PREVIEW_PDF_ERROR_INVOICE_FAIL,
  PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
} from "store/error-invoices/actionTypes";
import {
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailDataModal from "./DetailDataModal";
import { getStatus } from "./helper/functionHelper";
import HistoryTransferModal from "./modal/HistoryTransferModal";
import PDFViewModal from "./modal/PDFViewModal";
import { MODE, TCTBAO_LABEL } from "./utils";

const ListData = props => {
  const { addToast } = useToasts();
  const history = useHistory();
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  const [idHistory, setIdHistory] = useState(null);
  // Modal detail
  const [detailData, setDetailData] = useState(null);
  const [modalDetailData, setModalDetailData] = useState(false);
  const toggleDetailDataModal = () => setModalDetailData(!modalDetailData);
  // Modal listHDOn
  const [dataListHDon, setDataListHDon] = useState(null);
  const [modalListHDon, setModalListHDon] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleListHDonModal = () => setModalListHDon(!modalListHDon);

  // dataChangeInfo Modal
  const [dataChangeInfo, setDataChangeInfo] = useState({});
  const [changeInfoModal, setChangeInfoModal] = useState(false);
  const toggleChangeInfoModal = () => {
    setChangeInfoModal(!changeInfoModal);
  };

  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  const showSendMail = row => {
    setMailData({
      idInvoice: row.invoice_error_id,
      mailDefault: "",
    });
    toggleSendMailModal();
  };

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    fileDownload,
    fileDownloadName,
    type,
    previewPdfErrorFile,
    edit: errorInvoicesEdit,
    errorInvoicesDeleteData,
  } = errorInvoices;
  const { loading, listData, totalCount, columnsVisible, params } =
    errorInvoices.notificationErrorInvoices;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    exportInvoiceData,
    type: typeIssueInvoice,
    fileDownload: fileDownloadIssueInvoice,
    fileDownloadName: fileDownloadNameIssueInvoice,
  } = issueInvoice;

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    previewPdfRegisterFile,
    type: typePDF,
    fileDownload: fileDownloadPDF,
    fileDownloadName: fileDownloadNamePDF,
  } = dataFormat;
  const { t, i18n } = useTranslation(["errorInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));
  const [dataViewDocument, setDataViewDocument] = useState(null);
  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    switch (typeIssueInvoice) {
      case EXPORT_INVOICE_SUCCESS: {
        if (fileDownloadIssueInvoice !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadIssueInvoice;
          link.setAttribute("download", fileDownloadNameIssueInvoice);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      default:
        break;
    }
  }, [typeIssueInvoice]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);

  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);

  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);

  const Dashboard = useSelector(state => state.Dashboard);

  const { tenantCodeHeader, buStoreHeader, finalBuInfo } = Dashboard;

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ERROR_INVOICES_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      }
      case DOWNLOAD_XML_ERROR_INVOICES_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      case PREVIEW_PDF_ERROR_INVOICE_SUCCESS: {
        if (!modalPdfView) {
          if (previewPdfErrorFile !== null) {
            const link = document.createElement("a");
            link.href = previewPdfErrorFile.data;
            link.setAttribute("download", "error-invoice.pdf");
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      }
      case PREVIEW_PDF_ERROR_INVOICE_FAIL:
        if (!modalPdfView) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      case ERROR_INVOICES_DELETE_SUCCESS: {
        addToast("Xóa thông báo thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        dispatch(getListErrorInvoices(params, true));
        dispatch(resetErrorInvoicesDelete());
        break;
      }
      case ERROR_INVOICES_DELETE_FAIL:
        addToast("Xóa thông báo thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetErrorInvoicesDelete());
        break;
      default:
        break;
    }
  }, [type]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesEdit && errorInvoicesEdit.success) {
      addToast(
        t("message.update", {
          target: t("error_invoice"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      dispatch(resetEditErrorInvoices());
      dispatch(getListErrorInvoices(params, true));
      toggleDetailDataModal();
    }
  }, [errorInvoicesEdit]);
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      dispatch(getListErrorInvoices(params, true));
    }
  }, [finalBuInfo]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    initColumn();
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
    return () => {
      dispatch(resetListErrorInvoices());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {},
  };

  //path: approve-pdf
  //      review-pdf
  const showPdfById = invoice_id => {
    setDataViewDocument({
      id: invoice_id,
    });
    togglePdfViewModal();
  };
  const listRowAction = [
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem bản hiển thị",
      onClick: row => {
        showPdfById(row.invoice_id);
      },
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.invoice_id);
        toggleHistoryTransferModal();
      },
    },
    {
      icon: <i className="bx bx-mail-send text-success" />,
      text: "Gửi mail",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: {
        auth_status: [AUTH_STATUS_APPROVE],
      },
      onClick: row => {
        showSendMail(row);
      },
    },
  ];

  const selectFilterLoai = {
    1: "Thông báo hủy/giải trình của NNT",
    2: "Thông báo hủy/giải trình của NNT theo thông báo của CQT",
  };

  const getAuthStatus = (status, id) => {
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text,
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, //
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text,
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, //
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text,
    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text,
  };

  const initColumns = [
    {
      dataField: "invoice_id",
      text: "Id",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
    },

    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
    },
    {
      dataField: "shdon",
      text: "Số hóa đơn",
      hidden: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
    },
    {
      dataField: "khhdon",
      text: "Ký hiệu hóa đơn",
      hidden: false,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cellContent, row) => row.khmshdon + row.khhdon,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
        style: { width: "150px" },
      }),
    },
    {
      dataField: "auth_status",
      text: "Trạng thái",
      hidden: false,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: "Chọn",
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "invoice_error_id",
      text: "Thông báo sai sót",
      filter: textFilter({
        placeholder: "Nhập id thông báo",
      }),
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => {
              setDetailData({ ...row, mode: MODE.VIEW });
              toggleDetailDataModal();
            }}
            className="text-center"
            style={{ cursor: "pointer", fontSize: "15px" }}
          >
            <div className="text-success">ID: {cellContent}</div>
            <div className="text-warn">
              Tính chất: {TCTBAO_LABEL[row.tctbao]}
            </div>
            <div className="text-primary">(Xem thông báo)</div>
          </div>
        );
      },
    },
    {
      dataField: "changes_detail",
      text: "Nội dung sai sót bổ sung trong mail",
      hidden: false,
      formatter: cellContent => (
        <div
          className="text-center text-info"
          style={{
            verticalAlign: "middle",
            cursor: "pointer",
            fontSize: "18px",
          }}
          onClick={() => {
            if (cellContent) {
              setDataChangeInfo({
                nmua_dchi_old: cellContent.nmua_dchi_old || "",
                nmua_dchi_new: cellContent?.nmua_dchi_new || "",
                noidung_old: cellContent.noidung_old || "",
                noidung_new: cellContent?.noidung_new || "",
              });
            } else {
              setDataChangeInfo({});
            }
            toggleChangeInfoModal();
          }}
        >
          Xem nội dung
        </div>
      ),
    },
    {
      dataField: "note",
      text: "Ghi chú",
      hidden: false,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: cellContent => (
        <div
          style={{ whiteSpace: "pre-line", fontSize: "15px", color: "blue" }}
        >
          {cellContent}
        </div>
      ),
    },
  ];

  const listMultipleRowAction = [
    // {
    //   icon: <i className="far fa-file-excel font-size-18 text-success" />,
    //   text: "Xuất danh sách hóa đơn sai sót",
    //   isLoading: exportInvoiceData.loading,
    //   loadingText: "Đang xuất danh sách hóa đơn sai sót",
    //   onClick: data => {
    //     let objectExport = exportFormatData();
    //     objectExport = {
    //       ...objectExport,
    //       ...params.columnFilter,
    //       sort: params.sort ? params.sort : "-checker_date",
    //       keywords: params.keywords,
    //     };
    //     dispatch(
    //       exportInvoice(
    //         objectExport,
    //         getFileNameExcel("DanhSachHoaDonSaiSot"),
    //         "invoice-errors"
    //       )
    //     );
    //   },
    // },
  ];

  const formatDataHandle = (objectExport, dataField) => {
    switch (dataField) {
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][label]`] = "Số HĐ";
        break;
      case "ttchung_khhdon":
        objectExport[`columns[${dataField}][label]`] = "Ký hiệu HĐ";
        break;
      case "ttchung_nlap":
        objectExport[`columns[${dataField}][label]`] = "Ngày lập";
        break;
      case "mcqtcap":
        objectExport[`columns[${dataField}][label]`] = "Mã CQT cấp";
        break;
      case "ldo":
        objectExport[`columns[${dataField}][label]`] = "Lí do";
        break;
      case "auth_status":
        for (const key in selectFilterAuthStatus) {
          objectExport[`columns[${dataField}][mapping][${key}]`] =
            selectFilterAuthStatus[key];
        }
        break;
      case "ttchung_khmshdon":
        objectExport[`columns[${dataField}][mapping][1]`] = "HÓA ĐƠN GTGT";
        objectExport[`columns[${dataField}][mapping][2]`] = "HÓA ĐƠN BH";
        break;
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][mapping][null]`] = "Chờ cấp số";
        break;
      case "ntbao":
        objectExport[`columns[${dataField}][type]`] = "date";
        break;
      default:
        break;
    }
    // Format style
    switch (dataField) {
      case "nmua_ten":
        objectExport[
          `columns[${dataField}][contentOptions][alignment][wrapText]`
        ] = true;
        objectExport[`columns[${dataField}][dimensionOptions][width]`] = 80;
        break;
      default:
        objectExport[
          `columns[${dataField}][dimensionOptions][autoSize]`
        ] = true;
        break;
    }
  };

  const exportFormatData = () => {
    let objectExport = {};
    columns
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        if (formatData.dataField === "dshdon") {
          let expandFields = [
            "ttchung_shdon",
            "ttchung_khhdon",
            "ttchung_nlap",
            "mcqtcap",
            "ldo",
          ];
          for (const item of expandFields) {
            formatDataHandle(objectExport, item);
          }
        } else {
          formatDataHandle(objectExport, formatData.dataField);
          const value = formatData.text;
          objectExport[key] = value;
        }
        return formatData;
      });
    return objectExport;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListErrorInvoices(params, true));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListErrorInvoices(params, true));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleRegistryInvoices(field, value));
  };
  useEffect(() => {
    switch (typePDF) {
      case DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS: {
        if (fileDownloadPDF !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadPDF;
          link.setAttribute(
            "download",
            fileDownloadNamePDF || "Error-invoice.pdf"
          );
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
        break;
      }
      case DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL: {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
      }
      default:
        break;
    }
  }, [typePDF]);
  return (
    <React.Fragment>
      <ChangeInfoModal
        dataChange={dataChangeInfo}
        isOpen={changeInfoModal}
        isShowBtnUpdate={false}
        toggle={toggleChangeInfoModal}
      />
      {/* delete modal */}
      <ConfirmModal
        isOpen={modalConfirmDelete}
        titleHeader={"Xác nhận xóa thông báo"}
        titleBody={"Hệ thống sẽ thực hiện xóa thông báo này ?"}
        isDisableButton={errorInvoicesDeleteData.loading}
        onConfirm={note => {
          dispatch(errorInvoicesDelete(dataViewDocument.id));
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleConfirmDeleteModal}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"invoice-errors"}
      />
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
      ></PDFViewModal>
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={"invoices"}
      />
      <DetailDataModal
        detailData={detailData}
        isOpen={modalDetailData}
        toggle={toggleDetailDataModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>Danh sách hóa đơn sai sót</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={`Danh sách hóa đơn sai sót (${totalCount})`}
            breadcrumbItems={[
              { name: "Hóa đơn sai sót" },
              { name: "Danh sách hóa đơn sai sót" },
            ]}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    {/* SendMailModal */}
                    <SendMailModal
                      isOpen={modalSendMail}
                      mailData={mailData}
                      toggle={toggleSendMailModal}
                      isInvoiceError={true}
                    ></SendMailModal>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={
                        isRoleStore
                          ? listRowAction.filter(
                              item => item.text !== "Gửi duyệt thông báo"
                            )
                          : listRowAction
                      }
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    ></RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
